import React, { memo, useEffect, useState, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ListGroup, Button, Spinner } from "react-bootstrap";
import { truncateText } from "../../../utils/questionUtilities";
import withSubscriptionCheckButton from "../../../components/Common/withSubscriptionCheckButton";
import { getUserRole } from "../../../store/userRole";
import { useSelector } from "react-redux";
import FiChevronUp from "../../../constants/icons/Fi/FiChevronUp";
import FiChevronDown from "../../../constants/icons/Fi/FiChevronDown";
import { getAllAttemptsOfSomeExam } from "../../../utils/practices";
import { getUserAttemptsForExam } from "../../../utils/ieltsApi";
import EmptyScreen from "../../../components/EmptyScreen";
import { convertSecondsIntoMinutesAndHours } from "../../../utils/formater";
import RxStopwatch from "../../../constants/icons/Rx/RxStopwatch";
import BsClock from "../../../constants/icons/Bs/BsClock";
import moment from "moment";
import BsCalendar4Event from "../../../constants/icons/Bs/BsCalendar4Event";
import ShareModal from "../../../components/Classroom/ShareModal";
import * as ExamSlice from "../../../store/examSlice";
import {
  setAttemptedQuestions,
  setCurrentQuestionIndex,
  setCurrentSectionIndex,
  setExamId,
  setExamResults,
  setMarkedQuestions,
  setReviewMode,
  setSectionCorrectCounts,
  setShowBreakScreen,
  setStartTime,
  setTime,
  setTimeLeft,
  setUserAnswers,
  setExamData,
  setIsSavedExam,
  setSavedExamId,
  setSessionLogs,
} from "../../../store/fullLengthExam";
import FiTrash2 from "../../../constants/icons/Fi/FiTrash2";
import DeleteModal from "../../../components/Classroom/DeleteModal";
import {
  deleteExamAttempt,
  getExamAttemptById,
} from "../../../utils/assessments";
import { toast } from "react-toastify";
import he from "he";
import StopFullLengthExamAttempt from "../../../components/Classroom/StopFullLengthExamAttempt";

// Decode HTML entities and strip tags for plain text display
const decodeAndStripHtml = (html) => {
  if (!html) return "";
  const decoded = he.decode(html);
  const div = document.createElement("div");
  div.innerHTML = decoded;
  return div.textContent || div.innerText || "";
};

const OpenButton = withSubscriptionCheckButton(
  Button,
  "Full-Length Exams",
  true,
  true, // Pass the new flag to indicate it's for exams
);

const ReattemptButton = withSubscriptionCheckButton(
  Button,
  "Full-Length Exams",
  true,
  true, // Pass the new flag to indicate it's for exams
  "start-classroom-styles px-3",
);

function AttemptCard({
  type,
  attempt,
  index,
  isMobileView,
  onResume,
  onDelete,
  onView,
  isLoading,
  isSelected,
  ReattemptButton,
  setStopStart,
  handleStartClick,
  assessment,
  classroomId,
  hasValidSubscription,
  setOpenShareModal,
  roleOfTheUser,
}) {
  const duration =
    type === "completed"
      ? convertSecondsIntoMinutesAndHours(attempt?.timeSpent)
      : null;
  let displayTime = "";
  if (duration) {
    if (duration.hours > 0) displayTime += `${Math.ceil(duration.hours)}h `;
    if (duration.minutes > 0) displayTime += `${Math.ceil(duration.minutes)}m `;
    if (duration.seconds) displayTime += `${Math.ceil(duration.seconds)}s`;
    if (
      duration.hours === 0 &&
      duration.minutes === 0 &&
      duration.seconds === 0
    )
      displayTime += "0s";
  }
  return (
    <div key={index}>
      <div
        className="d-flex align-items-center justify-content-between"
        style={{ padding: "12px 24px 0px 24px" }}
      >
        <div>
          <div
            style={{
              fontSize: "14px",
              fontWeight: 600,
              lineHeight: "20px",
              letterSpacing: "-0.01em",
              textAlign: "left",
              color: "#1D2026",
              marginBottom: "12px",
            }}
          >
            {type === "saved" ? `Saved Exam ${index}` : `Attempt ${index}`}
          </div>
          <div
            className="d-flex align-items-center"
            style={{ marginBottom: "12px" }}
          >
            {type === "completed" && (
              <div
                className="d-flex align-items-center"
                style={{
                  color: "#8C94A3",
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "16px",
                  textAlign: "left",
                  gap: "6px",
                  marginRight: "12px",
                }}
              >
                <RxStopwatch size={20} style={{ color: "#1D2026" }} />
                {displayTime}
              </div>
            )}
            <div
              className="d-flex align-items-center"
              style={{
                color: "#8C94A3",
                fontSize: "12px",
                fontWeight: 400,
                lineHeight: "16px",
                textAlign: "left",
                gap: "6px",
                marginRight: "12px",
              }}
            >
              <BsClock size={20} style={{ color: "#1D2026" }} />
              {moment(attempt?.updatedAt).format("hh:mm a")}
            </div>
            <div
              className="d-flex align-items-center"
              style={{
                color: "#8C94A3",
                fontSize: "12px",
                fontWeight: 400,
                lineHeight: "16px",
                textAlign: "left",
                gap: "6px",
                marginRight: "12px",
              }}
            >
              <BsCalendar4Event size={20} style={{ color: "#1D2026" }} />
              {moment(attempt?.updatedAt).format("Do MMMM 'YY")}
            </div>
          </div>
        </div>
      </div>
      <div style={{ padding: "0px 24px 12px 24px" }}>
        <div
          className={
            type === "completed" && !isMobileView
              ? "d-flex align-items-center"
              : ""
          }
          style={{ gap: "14px" }}
        >
          {type === "saved" ? (
            <>
              <Button
                variant="light"
                className="start-classroom-styles px-3"
                onClick={onResume}
              >
                {isLoading && isSelected ? (
                  <Spinner style={{ height: "20px", width: "20px" }} />
                ) : (
                  "Resume"
                )}
              </Button>
              <FiTrash2
                size={24}
                onClick={onDelete}
                style={{ cursor: "pointer" }}
              />
            </>
          ) : (
            <>
              <Button
                variant="primary"
                className={`view-solution-classroom-styles px-3 ${
                  isMobileView ? "" : "m-0"
                }`}
                style={{ margin: isMobileView ? " 0px 14px 0px 0px" : "" }}
                onClick={onView}
              >
                {isLoading && isSelected ? (
                  <Spinner style={{ height: "20px", width: "20px" }} />
                ) : (
                  "View Attempt"
                )}
              </Button>
              <ReattemptButton
                onClick={() => {
                  if (isMobileView) {
                    setStopStart(true);
                  } else {
                    handleStartClick(assessment._id, assessment.examType);
                  }
                }}
                classRoomId={classroomId}
                requiredFeature="Full-Length Exams"
                hasValidSubscription={hasValidSubscription}
                index={index}
              >
                Reattempt
              </ReattemptButton>
              <Button
                variant="link"
                className="link-button-classroom-styles"
                onClick={() => setOpenShareModal(true)}
              >
                Challenge Friend
              </Button>
            </>
          )}
        </div>
      </div>
      <hr style={{ margin: "0px", width: "100%" }} />
    </div>
  );
}

function DetailsList({
  isMobileView,
  assessment = {},
  hasValidSubscription,
  handleStartClick = () => {},
  index,
  focusExam = "",
}) {
  const { id: classroomId } = useParams();
  const roleOfTheUser = useSelector(getUserRole);
  const [isLoading, setIsLoading] = useState(true);
  const [viewAttemptLoading, setViewAttemptLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [selectedAttempt, setSelectedAttempt] = useState("");
  const [isExpand, setisExpand] = useState(false);
  const [attemptsList, setAttemptsList] = useState([]);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [stopStart, setStopStart] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isTabScreen, setIsTabScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsTabScreen(window.innerWidth >= 768); // 768px is a common tablet+ threshold
    };

    checkScreenSize(); // initial check
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const toggleExpand = () => {
    setisExpand(!isExpand);
  };

  const getAssessmentAttempt = useCallback(async () => {
    try {
      setIsLoading(true);

      // Check if this is an IELTS exam
      if (assessment?.examType === "ielts") {
        // Fetch IELTS attempts
        const response = await getUserAttemptsForExam(assessment?._id);
        if (response.success && response.attempts) {
          // Transform IELTS attempts to match regular attempt structure
          const transformedAttempts = response.attempts
            .filter((attempt) => attempt.isCompleted) // Only show completed attempts
            .map((attempt) => ({
              _id: attempt._id,
              inProgress: false, // IELTS doesn't support saved/in-progress state
              timeSpent:
                attempt.listeningAttempt?.timeSpent +
                  attempt.readingAttempt?.timeSpent +
                  attempt.writingAttempt?.timeSpent +
                  attempt.speakingAttempt?.timeSpent || 0,
              updatedAt: attempt.updatedAt || attempt.createdAt,
              overallBandScore: attempt.overallBandScore,
              attemptType: attempt.attemptType,
            }));
          setAttemptsList(transformedAttempts);
        } else {
          setAttemptsList([]);
        }
      } else {
        // Fetch regular assessment attempts
        const response = await getAllAttemptsOfSomeExam(assessment?._id, {
          isShortForm: true,
          classroomId,
        });
        if (response.ok && response?.data?.examAttempts) {
          setAttemptsList(response?.data?.examAttempts);
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching attempts:", error.message);
    }
  }, [assessment?._id, assessment?.examType, classroomId]);

  const hostURL = window.location.protocol
    .concat("//")
    .concat(window.location.host);

  useEffect(() => {
    if (isExpand) {
      getAssessmentAttempt();
    }
  }, [isExpand, getAssessmentAttempt]);

  const inCompletedAttempts = useMemo(
    () => attemptsList.filter((attempt) => attempt?.inProgress),
    [attemptsList],
  );
  const completedAttempts = useMemo(
    () => attemptsList.filter((attempt) => !attempt?.inProgress),
    [attemptsList],
  );

  const deleteAttemptHandler = useCallback(async () => {
    try {
      setIsLoading(true);
      await deleteExamAttempt(selectedAttempt);
      setOpenDeleteModal(false);
      setSelectedAttempt("");
      getAssessmentAttempt();
    } catch (err) {
      toast.error("Failed to delete saved exam");
      setIsLoading(false);
      console.error(err);
    }
  }, [selectedAttempt, getAssessmentAttempt]);

  const getAttemptHandler = useCallback(async (attemptId, setLoader) => {
    let attemptData = null;
    try {
      setLoader(true);
      const resp = await getExamAttemptById(attemptId);
      if (resp?.examAttempt) {
        attemptData = structuredClone(resp?.examAttempt);
      }
      setLoader(false);
    } catch (err) {
      toast.error("Failed to delete saved exam");
      setLoader(false);
      console.error(err);
    }
    return attemptData;
  }, []);

  return (
    <ListGroup.Item
      key={assessment._id}
      className="py-3"
      id={assessment?._id}
      style={{
        boxShadow:
          focusExam === assessment?._id ? "0 0 6px rgba(35, 173, 278, 1)" : "",
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ flexDirection: "row" }}
      >
        {openDeleteModal && (
          <DeleteModal
            open={openDeleteModal}
            onClose={setOpenDeleteModal}
            onSubmit={deleteAttemptHandler}
            buttonText={"Delete"}
            title={"Delete Saved Exam"}
            message={
              "Are you sure you want to delete this saved exam? This action cannot be undone."
            }
          />
        )}
        <ShareModal
          open={openShareModal}
          onClose={setOpenShareModal}
          title={"Share this Full Length Exam"}
          message={"If you like this article, share it with your friends."}
          shareLink={`${hostURL}/register?classroomId=${classroomId}&redirect=student/${classroomId}/exams/${assessment._id}/details`}
        />
        {stopStart && (
          <StopFullLengthExamAttempt
            open={stopStart}
            onClose={() => setStopStart(!stopStart)}
            title={"Exam Device Advisory"}
            message={
              "Please attempt the full-length exam on a laptop for an optimal experience. Mobile devices are not recommended."
            }
          />
        )}
        <div
          className="d-flex align-items-center"
          style={{ flexDirection: "row", whiteSpace: "non-wrap" }}
        >
          {isExpand ? (
            <FiChevronUp
              size={30}
              onClick={toggleExpand}
              style={{ marginRight: "15px", cursor: "pointer" }}
            />
          ) : (
            <FiChevronDown
              size={30}
              onClick={toggleExpand}
              style={{ marginRight: "15px", cursor: "pointer" }}
            />
          )}
          <div className="ml-3">
            <div>
              {isMobileView
                ? truncateText(assessment.name, 30)
                : assessment.name}
            </div>
            <div>
              {isMobileView
                ? truncateText(
                    decodeAndStripHtml(assessment.shortDescription),
                    50,
                  )
                : truncateText(
                    decodeAndStripHtml(assessment.shortDescription),
                    140,
                  )}
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center">
          {roleOfTheUser === "Student" ? (
            <OpenButton
              onClick={() => {
                if (!isTabScreen) {
                  setStopStart(true);
                } else {
                  handleStartClick(assessment._id, assessment.examType);
                }
              }}
              classRoomId={classroomId}
              requiredFeature="Full-Length Exams"
              hasValidSubscription={hasValidSubscription}
              index={index}
            >
              Start
            </OpenButton>
          ) : (
            <Button
              onClick={() => {
                if (!isTabScreen) {
                  setStopStart(true);
                } else {
                  handleStartClick(assessment._id, assessment.examType);
                }
              }}
              className="start-classroom-styles"
              variant="outline-primary"
            >
              Start
            </Button>
          )}
        </div>
      </div>
      {isExpand && !isLoading && (
        <>
          {attemptsList?.length ? (
            <>
              {inCompletedAttempts?.length !== 0 && (
                <>
                  <div
                    style={{
                      borderTop: "3px solid lightgray",
                      marginTop: "10px",
                      fontSize: "20px",
                      fontWeight: 700,
                      marginLeft: "24px",
                    }}
                  >
                    Saved Exams
                  </div>
                  {inCompletedAttempts.map((attempt, idx) => (
                    <AttemptCard
                      key={attempt._id}
                      type="saved"
                      attempt={attempt}
                      index={inCompletedAttempts.length - idx}
                      isMobileView={isMobileView}
                      onResume={async () => {
                        setSelectedAttempt(attempt?._id);
                        const attemptData = await getAttemptHandler(
                          attempt?._id,
                          setButtonLoading,
                        );
                        const parsedData = JSON.parse(attemptData?.data);
                        dispatch(setSessionLogs(parsedData?.sessionLogs));
                        dispatch(
                          setCurrentQuestionIndex(
                            parsedData?.currentQuestionIndex,
                          ),
                        );
                        dispatch(
                          setCurrentSectionIndex(
                            parsedData?.currentSectionIndex,
                          ),
                        );
                        dispatch(
                          setAttemptedQuestions(parsedData?.attemptedQuestions),
                        );
                        dispatch(setExamId(parsedData?.examId));
                        dispatch(setExamResults(parsedData?.examResults));
                        dispatch(
                          setMarkedQuestions(parsedData?.markedQuestions),
                        );
                        dispatch(setReviewMode(parsedData?.reviewMode));
                        dispatch(
                          setSectionCorrectCounts(
                            parsedData?.sectionCorrectCounts,
                          ),
                        );
                        dispatch(
                          setShowBreakScreen(parsedData?.showBreakScreen),
                        );
                        dispatch(setStartTime(parsedData?.startTime));
                        dispatch(setTime(parsedData?.time));
                        dispatch(setTimeLeft(parsedData?.timeLeft));
                        dispatch(setUserAnswers(parsedData?.userAnswers));
                        dispatch(setExamData(parsedData?.examData));
                        dispatch(setIsSavedExam(true));
                        dispatch(setSavedExamId(attempt?._id));
                        setButtonLoading(true);
                        setSelectedAttempt(attempt?._id);
                        setTimeout(() => {
                          setButtonLoading(false);
                          navigate(
                            `${
                              roleOfTheUser === "Student" ? "/student" : ""
                            }/${classroomId}/exams/${assessment?._id}`,
                          );
                        }, [1500]);
                      }}
                      onDelete={() => {
                        setSelectedAttempt(attempt?._id);
                        setOpenDeleteModal(true);
                      }}
                      isLoading={
                        buttonLoading && attempt?._id === selectedAttempt
                      }
                      isSelected={attempt?._id === selectedAttempt}
                      ReattemptButton={ReattemptButton}
                      setStopStart={setStopStart}
                      handleStartClick={handleStartClick}
                      assessment={assessment}
                      classroomId={classroomId}
                      hasValidSubscription={hasValidSubscription}
                      setOpenShareModal={setOpenShareModal}
                      roleOfTheUser={roleOfTheUser}
                    />
                  ))}
                </>
              )}
              {completedAttempts?.length !== 0 && (
                <>
                  <div
                    style={{
                      borderTop: inCompletedAttempts?.length
                        ? ""
                        : "3px solid lightgray",
                      marginTop: inCompletedAttempts?.length ? "" : "10px",
                      fontSize: "20px",
                      fontWeight: 700,
                      marginLeft: "24px",
                    }}
                  >
                    Exam Attempts
                  </div>
                  {completedAttempts.map((attempt, index) => {
                    const duration = convertSecondsIntoMinutesAndHours(
                      attempt?.timeSpent,
                    );
                    let displayTime = "";
                    if (duration.hours > 0) {
                      displayTime += `${Math.ceil(duration.hours)}h `;
                    }
                    if (duration.minutes > 0) {
                      displayTime += `${Math.ceil(duration.minutes)}m `;
                    }
                    if (duration.seconds) {
                      displayTime += `${Math.ceil(duration.seconds)}s`;
                    }
                    if (
                      duration.hours === 0 &&
                      duration.minutes === 0 &&
                      duration.seconds === 0
                    ) {
                      displayTime += "0s";
                    }
                    return (
                      <div key={index}>
                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{
                            padding: "12px 24px 0px 24px",
                          }}
                        >
                          <div>
                            <div
                              style={{
                                fontSize: "14px",
                                fontWeight: 600,
                                lineHeight: "20px",
                                letterSpacing: "-0.01em",
                                textAlign: "left",
                                color: "#1D2026",
                                marginBottom: "12px",
                              }}
                            >{`Attempt ${
                              completedAttempts?.length - index
                            }`}</div>
                            <div
                              className="d-flex align-items-center"
                              style={{ marginBottom: "12px" }}
                            >
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  color: "#8C94A3",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  lineHeight: "16px",
                                  textAlign: "left",
                                  gap: "6px",
                                  marginRight: "12px",
                                }}
                              >
                                <RxStopwatch
                                  size={20}
                                  style={{ color: "#1D2026" }}
                                />
                                {displayTime}
                              </div>
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  color: "#8C94A3",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  lineHeight: "16px",
                                  textAlign: "left",
                                  gap: "6px",
                                  marginRight: "12px",
                                }}
                              >
                                <BsClock
                                  size={20}
                                  style={{ color: "#1D2026" }}
                                />
                                {moment(attempt?.updatedAt).format("hh:mm a")}
                              </div>
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  color: "#8C94A3",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  lineHeight: "16px",
                                  textAlign: "left",
                                  gap: "6px",
                                  marginRight: "12px",
                                }}
                              >
                                <BsCalendar4Event
                                  size={20}
                                  style={{ color: "#1D2026" }}
                                />
                                {moment(attempt?.updatedAt).format(
                                  "Do MMMM 'YY",
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ padding: "0px 24px 12px 24px" }}>
                          <div
                            className={
                              isMobileView ? "" : "d-flex align-items-center"
                            }
                            style={{ gap: "14px" }}
                          >
                            <Button
                              variant="primary"
                              className={`view-solution-classroom-styles px-3 ${
                                isMobileView ? "" : "m-0"
                              }`}
                              style={{
                                margin: isMobileView ? " 0px 14px 0px 0px" : "",
                              }}
                              onClick={async () => {
                                if (!isTabScreen) {
                                  setStopStart(true);
                                  return;
                                }

                                setSelectedAttempt(attempt?._id);

                                // Handle IELTS exam attempts differently
                                if (assessment?.examType === "ielts") {
                                  // For IELTS, store attempt ID in sessionStorage and navigate to results
                                  sessionStorage.setItem(
                                    "fullExamAttemptId",
                                    attempt?._id,
                                  );
                                  setViewAttemptLoading(true);
                                  setTimeout(() => {
                                    navigate(
                                      `${
                                        roleOfTheUser === "Student"
                                          ? "/student"
                                          : ""
                                      }/myClassrooms/${classroomId}/ielts-exams/${
                                        assessment?._id
                                      }/attempt/results`,
                                    );
                                  }, 500);
                                } else {
                                  // Regular assessment attempt
                                  const attemptData = await getAttemptHandler(
                                    attempt?._id,
                                    setViewAttemptLoading,
                                  );
                                  dispatch(
                                    ExamSlice.setExamData({
                                      ...JSON.parse(attemptData?.data),
                                      updatedAt: attempt?.updatedAt,
                                      urlData: JSON.parse(attemptData?.url),
                                    }),
                                  );
                                  setViewAttemptLoading(true);
                                  navigate(
                                    `${
                                      roleOfTheUser === "Student"
                                        ? "/student"
                                        : ""
                                    }/${classroomId}/exams/${
                                      assessment?._id
                                    }/result?attemptId=${attempt?._id}`,
                                  );
                                }
                              }}
                            >
                              {viewAttemptLoading &&
                              attempt?._id === selectedAttempt ? (
                                <Spinner
                                  style={{
                                    height: "20px",
                                    width: "20px",
                                  }}
                                />
                              ) : (
                                "View Attempt"
                              )}
                            </Button>
                            {roleOfTheUser === "Student" ? (
                                                          <ReattemptButton
                              onClick={() => {
                                if (!isTabScreen) {
                                  setStopStart(true);
                                } else {
                                  handleStartClick(
                                    assessment._id,
                                    assessment.examType,
                                  );
                                }
                              }}
                              classRoomId={classroomId}
                              requiredFeature="Full-Length Exams"
                              hasValidSubscription={hasValidSubscription}
                              index={index} // Pass the index to check max allowed
                            >
                              Reattempt
                            </ReattemptButton>
                            ) : (
                              <Button
                              variant="light"
                              className="start-classroom-styles px-3"
                              onClick={() => {
                                if (isMobileView) {
                                  setStopStart(true);
                                } else {
                                  handleStartClick(
                                    assessment._id,
                                    assessment.examType,
                                  );
                                }
                              }}
                            >
                              Reattempt
                            </Button>
                            )}
                            <Button
                              variant="link"
                              className="link-button-classroom-styles"
                              onClick={() => {
                                setOpenShareModal(true);
                              }}
                            >
                              Challenge Friend
                            </Button>
                          </div>
                        </div>
                        <hr style={{ margin: "0px", width: "100%" }} />
                      </div>
                    );
                  })}
                </>
              )}
            </>
          ) : (
            <EmptyScreen heading="No Exams Attempts Found" subHeading="" />
          )}
        </>
      )}
      {isExpand && isLoading && (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: `100px`, width: "100%" }}
        >
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
    </ListGroup.Item>
  );
}

export default memo(DetailsList);
